import {
  SubmissionStatus,
  useUpsertSubmissionMutation,
} from '@converge/graphql';

import { ComponentProps } from 'react';
import { LoadingButton } from '@mui/lab';
import { NewConvergeButton } from '../../../presentation';
import { useCallback } from 'react';
import { useConvergeSnackBar } from '../../../contexts';

interface IReopenSubmissionButtonProps
  extends ComponentProps<typeof LoadingButton> {
  referenceId?: string;
  submissionId: string;
}

export const ReopenSubmissionButton = ({
  referenceId,
  submissionId,
  ...props
}: IReopenSubmissionButtonProps) => {
  const { notify, closeSnackbar } = useConvergeSnackBar();
  const { upsertSubmission, loading: isUpdatingSubmission } =
    useUpsertSubmissionMutation({});

  const reopenSubmissionConfirmationEvent = useCallback(
    async (submissionUuid: string) => {
      closeSnackbar();

      try {
        await upsertSubmission({
          variables: {
            details: {
              uuid: submissionUuid,
              // i have to change it to undo lost when backend is ready
              status: SubmissionStatus.Reactivated,
            },
          },
        });
        notify('Saved successfully', {
          variant: 'success',
        });
      } catch (cause) {
        closeSnackbar();
        notify(
          cause instanceof Error
            ? `Error saving: ${cause.message}`
            : 'Error saving',
          {
            variant: 'error',
          }
        );
      }
    },
    [closeSnackbar, notify, upsertSubmission]
  );

  return (
    <>
      <NewConvergeButton
        {...props}
        loading={isUpdatingSubmission}
        variant="contained"
        onClick={() => reopenSubmissionConfirmationEvent(submissionId)}
        label="Reopen"
      />
    </>
  );
};
